import { type FC, useEffect, useState } from 'react';

interface UpdatingOverlayProps {
  /** Whether the indicator should be visible */
  isVisible: boolean;
}

const TIMEOUT_MS = 20000; // 20 seconds

/**
 * Small spinner indicator shown in the header row
 * while a meeting update API call is in progress.
 * After 20 seconds, shows a connection error message.
 */
const UpdatingOverlay: FC<UpdatingOverlayProps> = ({ isVisible }) => {
  const [hasTimedOut, setHasTimedOut] = useState(false);

  useEffect(() => {
    if (!isVisible) {
      setHasTimedOut(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      setHasTimedOut(true);
    }, TIMEOUT_MS);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="personal-meetings-modal__updating-indicator" aria-live="polite">
      <div className="personal-meetings-modal__updating-spinner" />
      <span className="personal-meetings-modal__updating-text">
        {hasTimedOut ? 'Connection lost' : 'Saving…'}
      </span>
    </div>
  );
};

export default UpdatingOverlay;
